// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BuildCashRegisterCreditNoteQueryVariables = Types.Exact<{
  buildCashRegisterCreditNoteRequestDTO: Types.BuildCashRegisterCreditNoteRequestDtoInput;
}>;


export type BuildCashRegisterCreditNoteQueryResult = { __typename?: 'Query', buildCashRegisterCreditNote: { __typename?: 'CashRegisterCreditNoteDTO', closure: string, date: LocalDateTime, documentNumber: string } | null };

export const BuildCashRegisterCreditNoteGql = gql`
    query BuildCashRegisterCreditNote($buildCashRegisterCreditNoteRequestDTO: BuildCashRegisterCreditNoteRequestDTOInput!) {
  buildCashRegisterCreditNote(
    buildCashRegisterCreditNoteRequestDTO: $buildCashRegisterCreditNoteRequestDTO
  ) {
    closure
    date
    documentNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BuildCashRegisterCreditNoteInjectable extends Apollo.Query<BuildCashRegisterCreditNoteQueryResult, BuildCashRegisterCreditNoteQueryVariables> {
    override document = BuildCashRegisterCreditNoteGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */